import { fetchAccountStatusFallback } from 'modules/accountStatus/actions/fetchAccountStatus';
import { selectIsAccountEligible } from 'modules/referralProgram/store/selectors';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useAppSelector } from 'store/useAppSelector';
import { usePersonalAccountStatus } from 'modules/personalAccount/hooks/usePersonalAccountStatus';
import { useReferrer } from 'modules/referralProgram/hooks/useReferrer';
import { useSignOut } from 'modules/auth/hooks/useSignOut';

export const useHasReferralCodeButton = () => {
  const { isPersonalAccount } = useAccount();

  const { personalAccountStatus, userEndpointToken } = usePersonalAccountStatus(
    { skipFetching: true },
  );

  const { isSigningOut } = useSignOut();

  const isPersonalAccountStatusLoaded =
    personalAccountStatus !== fetchAccountStatusFallback;

  const { isLoading: isReferrerLoading, referrer } = useReferrer({
    skipFetching: true,
  });

  const isAccountEligible = useAppSelector(state =>
    selectIsAccountEligible(state, { userEndpointToken: userEndpointToken! }),
  );

  const hasReferrer = Boolean(referrer);

  const hasReferralCodeButton =
    isAccountEligible &&
    isPersonalAccount &&
    isPersonalAccountStatusLoaded &&
    !hasReferrer &&
    !isReferrerLoading &&
    !isSigningOut;

  return { hasReferralCodeButton };
};
